<template>
    <div class="search-control"
         id="search-control">
        <div class="header-container">
            <div class="tab-container">
                <span id="search-source-tab"
                      :class="['tab-item', { active: searchField === SearchField.Source }]"
                      @click="setSearchField(SearchField.Source)">
                    {{ $t('segmentSearch.sourceSegment') }}
                </span>
                <span id="search-target-tab"
                      :class="['tab-item', { active: searchField === SearchField.Target }]"
                      @click="setSearchField(SearchField.Target)">
                    {{ $t('segmentSearch.targetSegment') }}
                </span>
            </div>
            <ConcordanceSearch :translationConfig="translationConfig" />
        </div>

        <SegmentSearch :searchField="searchField" />
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { SearchField } from './SegmentSearchModels';
    import SegmentSearch from './SegmentSearch.vue';
    import ConcordanceSearch from './ConcordanceSearch.vue';
    import { TranslationConfiguration } from '@/models/TranslationConfiguration';

    export default defineComponent({
        name: 'SearchControl',
        components: {
            SegmentSearch,
            ConcordanceSearch
        },
        props: {
            translationConfig: {
                type: Object as PropType<TranslationConfiguration | null>,
                default: null
            }
        },
        data() {
            return {
                searchField: SearchField.Source,
                SearchField: SearchField
            };
        },
        methods: {
            setSearchField(field: SearchField) {
                this.searchField = field;
            }
        }
    });
</script>

<style lang="scss" scoped>
    .search-control {
        padding: 5px 20px 16px 20px;
        background-color: var(--el-bg-color);
        border-radius: 4px;
    }

    .header-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
    }

    .tab-container {
        display: flex;
        gap: 32px;
    }

    .tab-item {
        font-size: 16px;
        font-weight: 600;
        color: var(--text-color);
        cursor: pointer;
        padding: 8px 0;
        position: relative;
        transition: color 0.2s ease;

        &.active {
            color: var(--yellow);

            &::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                height: 3px;
                background-color: var(--yellow);
                border-radius: 2px;
            }
        }

        &:hover:not(.active) {
            opacity: 0.7;
        }
    }
</style>
